import { OrganizationId } from '@kaizenplatform/kaizen-id-entity';
import Store from 'repatch';

import State from '../core/State';
import OrganizationWebApi from '../service/persistent/OrganizationWebApi';
import {
  setLastAccessedOrganization,
  updateLastAccessedOrganizationPointBalance,
} from '../thunk/lastAccessedOrganization';

class OrganizationUsecase {
  private readonly store: Store<State>;
  private organizationWebApi: OrganizationWebApi;

  constructor({ store, organizationWebApi }: { store: Store<State>; organizationWebApi: OrganizationWebApi }) {
    this.store = store;
    this.organizationWebApi = organizationWebApi;
  }

  public refreshPointBalance = async (organizationId: OrganizationId): Promise<void> => {
    const organization = await this.organizationWebApi.getById(organizationId);
    this.store.dispatch(setLastAccessedOrganization(organization));
  };

  public addPurchasedPointBalance = async (purchasedPoint: number): Promise<void> => {
    await this.store.dispatch(updateLastAccessedOrganizationPointBalance(purchasedPoint));
  };
}

export default OrganizationUsecase;
